import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { theme } from '@contrast-security-inc/design-system-foundations'

const footerWrapperStyles = css`
  & p {
    margin: 30px 0;
  }
`

const backgroundStyles = css`
  padding: 16px;
  border-top: 1px solid ${theme.color.neutral30};
  background-color: ${theme.color.neutral10};
  width: 100%;
`

interface NotificationFooterProps {
  routeToAccountNotifications: () => void
}

export const NotificationFooter: FC<NotificationFooterProps> = ({
  routeToAccountNotifications
}) => {
  const { formatMessage } = useIntl()

  return (
    <Stack
      data-testid="notification-footer"
      flexDirection="column"
      alignItems="center"
      className={footerWrapperStyles}
    >
      <Stack
        justifyContent="space-between"
        alignItems="center"
        className={backgroundStyles}
      >
        <Text font="metadata" color="neutral80">
          {formatMessage({ id: 'detail_notifications_subscribe' })}
        </Text>
        <Link
          font="metadata"
          onClick={routeToAccountNotifications}
          testId="notification-footer-manage-settings"
        >
          {formatMessage({ id: 'detail_notifications_manageSettings' })}
        </Link>
      </Stack>
    </Stack>
  )
}
